<template>
    <div>
        <div class="row" v-for="(row, index) in rows" :key="index">
            <div class="col-md-4" v-for="address in row" :key="address.id">
                <div class="box">
                    <div class="box-copy box-inner">
                        <account-address
                    :id="address.id"
                    :firstname="address.firstname"
                    :lastname="address.lastname"
                    :line-one="address.address"
                    :line-two="address.address_two"
                    :city="address.city"
                    :state="address.state"
                    :county="address.county"
                    :country="address.country"
                    :postal-code="address.postal_code"
                    @remove="remove"
                >
                </account-address>
                    </div>
                </div>
            </div>
        </div>
        <div class="alert alert-info" v-if="!rows.length">
            You do not have any saved addresses
        </div>
        <button class="add-btn" @click="create">Add new address</button>
        <account-address-modal :billing="billing" :show="creating" :address="newAddress" @saved="saved" @cancel="cancel"></account-address-modal>
        <!--
             @foreach($shipping_addresses->chunk(4) as $row)
                <div class="row">
                    @foreach($row as $index => $address)
                        <div class="col-md-4">
                            <div class="box">
                                <div class="box-inner box-copy">
                                    <account-address
                                        id="{{ $address->id }}"
                                        firstname="{{ $address->firstname }}"
                                        lastname="{{ $address->lastname }}"
                                        line-one="{{ $address->address }}"
                                        line-two="{{ $address->address_two }}"
                                        city="{{ $address->city }}"
                                        state="{{ $address->state }}"
                                        county="{{ $address->county }}"
                                        country="{{ $address->country }}"
                                        zip="{{ $address->zip }}"
                                    >
                                    </account-address>
                                </div>
                            </div>
                        </div>
                    @endforeach
                </div>
            @endforeach
        -->
    </div>
</template>

<script>
    import AccountAddressModal from './AccountAddressModal.vue';

    export default {
        components: {
            AccountAddressModal
        },
        props: {
            addresses: {
                type: [Array, Object]
            },
            billing: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                creating: false,
                newAddress: {},
                items() {
                    return [];
                }
            }
        },
        mounted() {
            this.items = this.addresses;
        },
        computed: {
            rows() {
                return _.chunk(this.items, 3);
            }
        },
        methods: {
            remove(id) {
                this.items = _.reject(this.items, add => {
                    return add.id == id;
                });
            },
            cancel() {
                this.creating = false;
            },
            create() {
                this.creating = true;
                this.newAddress = {
                    firstname: '',
                    lastname: '',
                    address: '',
                    address_two: '',
                    address_three: '',
                    city: '',
                    county: '',
                    country: '',
                };
            },
            saved(address) {
                this.creating = false;
                this.items.push(address);
            }
        }
    }
</script>

<style scoped lang="scss">
    .add-btn {
        border:none;
        width:100%;
        background-color:#f5f5f5;
        padding:.5em 0;
        &:hover {
            background-color:darken(#f5f5f5, 5%);
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Account/AccountAddresses.vue